import Validator from 'validator';
import isEmpty from 'is-empty';

export function validateAuthenticateInputs(data) {
  const errors = {};

  if (Validator.isEmpty(data.username)) {
    errors.username = 'Username is required.';
  }

  if (Validator.isEmpty(data.password)) {
    errors.password = 'Password is required.';
  }

  return {
    errors,
    valid: isEmpty(errors),
  };
}

export function validateRecoveryEmail(data) {
  const errors = {};

  if (Validator.isEmpty(data.email)) {
    errors.email = 'Please enter your recovery email address.';
  } else if (!Validator.isEmail(data.email)) {
    errors.email = 'Please enter a valid email address.';
  }

  return {
    errors,
    valid: isEmpty(errors),
  };
}
